import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'app-single-upload',
  templateUrl: './single-upload.component.html',
  styleUrls: ['./single-upload.component.scss']
})
export class SingleUploadComponent implements OnInit, AfterViewInit {

/* ---------------------------------- Field --------------------------------- */

  @Input() singleFile: File;
  @Output() output = new EventEmitter();

  url: string;
  progress = 0;

  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';

/* ------------------------------- constructor ------------------------------ */

  constructor(private mediaService: MediaService) { }

/* ------------------------------- Life cycle ------------------------------- */

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    const formData = new FormData();
    formData.append("file", this.singleFile);
    formData.append("fileType", "IMAGE");
    formData.append("directory", "uploads");
    formData.append("client_id", "ac3b48cd-1183-47d7-89eb-d97137f190c9");
    formData.append('Content-Type', 'application/json');
    formData.append('accept', 'application/json');
    this.mediaService.uploadMedia(formData).subscribe(response => {
      console.log(response);
      if (response.message) {
        this.progress = response.message;
      }
      if (response.url) {
        this.url = response.url;
        this.output.emit(response);
        this.progress = 0;
      }
    });
  }

}
